// extracted by mini-css-extract-plugin
export default {"container":"_bbb5d111","success":"_f9155e15","warning":"_b6b0349c","spacer":"_65109140"};